/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as RepoDefs from './defs.defs'

const $nsid = 'com.atproto.repo.deleteRecord'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  repo: /*#__PURE__*/ l.string({ format: 'at-identifier' }),
  rkey: /*#__PURE__*/ l.string({ format: 'record-key' }),
  collection: /*#__PURE__*/ l.string({ format: 'nsid' }),
  swapCommit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'cid' }),
  ),
  swapRecord: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'cid' }),
  ),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  commit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<RepoDefs.CommitMeta>(
      (() => RepoDefs.commitMeta) as any,
    ),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Delete a repository record, or ensure it doesn't exist. Requires auth, implemented by PDS. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'InvalidSwap',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
